import { Button, Grid, Typography } from "@mui/material";
import { BCPShop, BCPSquarePlus } from "../../../components/icons/bcp/BCPIcons";
import { isAppMode } from "../../../global/AppOverlay";

import ListResponsive from "../../../components/other/ListResponsive";
import InfoContainer from "../../../components/layout/InfoContainer";
import OrganizationCardSmall from "../../../components/layout/OrganizationCardSmall";

export default function OrgDashOrganizations(props) {
  const { loading, organizations, t } = props;
  const appMode = isAppMode();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={8}>
        <Typography variant="h3" fontWeight="700">
          {t("managedOrganizations")}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Button
          variant="contained"
          href="/organize/game-stores"
          target={`${appMode ? "_blank" : "_self"}`}
          startIcon={<BCPShop />}
          fullWidth
        >
          {t("viewMyOrganizations")}
        </Button>
      </Grid>

      <Grid item xs={12}>
        {!loading && !organizations?.length ? (
          <InfoContainer
            title={t("noOrganizationsFoundTitle")}
            body={t("noOrganizationsFoundDescription")}
            ActionButton={
              <Button
                variant="contained"
                href={"/organize/organization"}
                startIcon={<BCPSquarePlus />}
              >
                {t("createOrganization")}
              </Button>
            }
            sx={{ mt: 1 }}
          />
        ) : (
          <ListResponsive
            name="Managed organizations"
            originalList={
              loading ? null : organizations?.length ? organizations : []
            }
            doPages
            initialRowsPerPage={9}
            itemsPerPage={[9]}
            centerNav
            buttonGroup={false}
            rowProps={{
              mapFunction: (row, index) => (
                <Grid key={index} item xs={12} sm={6} md={4} sx={{ p: 1 }}>
                  <OrganizationCardSmall
                    organization={row}
                    key={row?.id || index}
                    organize
                  />
                </Grid>
              )
            }}
          />
        )}
      </Grid>
    </Grid>
  );
}
